import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Alert, Button, Flex, Input, Spin, Table, Typography } from "antd"
import { ColumnsType } from "antd/es/table";

/**
 * Standard data table offering search, CRUD, error handling and reload
 * capabilities
 */
export default function DataTable<T extends object>(props: {
  searchQuery: string;
  setSearchQuery: (s: string) => void;

  columns: ColumnsType<T>;

  data: T[],
  error?: boolean;
  isFetching: boolean;
  refetch: () => void;

  onCreate?: () => void;
}) {
  return <>
    <Flex gap={8} vertical>
    <Input.Search
      placeholder={`Search`}
      enterButton="Search"
      value={props.searchQuery}
      onChange={e => props.setSearchQuery(e.target.value)}
      // onSearch={handleSearch}
    />
    <Flex justify="space-between" align="center">
      <Flex align="center">
        <Typography.Text>
          {props.data && !props.isFetching && !props.error
            ? `${props.data.length} record${props.data.length !== 1 ? "s" : ""} found`
            : ""
          }
        </Typography.Text>
        {/* {data && !isFetching && canLoadMore &&
          <Button type="link" onClick={handleLoadMore}>Load More</Button>
        } */}
      </Flex>
      <Flex gap={8}>
        { props.onCreate &&
          <Button icon={<PlusOutlined />} onClick={props.onCreate} />
        }
        <Button icon={<ReloadOutlined />} onClick={props.refetch} />
      </Flex>
    </Flex>
    { props.error &&
      <Alert
        message="Error loading data"
        description="There was an error loading data mappings"
        type="error"
        showIcon
        action={
          <Button danger onClick={props.refetch}>
            Try Again
          </Button>
        }
      />
    }
    {/* { props.isFetching && <Spin /> } */}
    {/* <Tabs
      activeKey={vendorId}
      onChange={handleTabChange}
      items={tabItems}
    /> */}
    <Table
      dataSource={props.data}
      columns={props.columns}
      loading={props.isFetching}
      rowKey="Id"
    />
    </Flex>
  </>
}